import { hasWindow } from "./hasWindow";

// получение значения get параметра из урла
export const getQueryParam = (queryName: string) => {
  if (hasWindow && window.location.href) {
    const url = new URL(window.location.href);
    return url.searchParams.get(queryName);
  }

  return null;
};

export const reloadWithParams = (
  paramsToAdd?: Record<string, any>,
  paramsToRemove?: string[]
) => {
  if (!hasWindow) {
    return;
  }

  const url = new URL(window.location.href);

  if (paramsToRemove) {
    paramsToRemove.forEach(param => {
      url.searchParams.delete(param);
    });
  }

  if (paramsToAdd) {
    Object.entries(paramsToAdd).forEach(([key, value]) => {
      url.searchParams.set(key, value); // Add new params or overwrite existing ones
    });
  }

  window.location.href = url.href;
};
